import jwt_decode from "jwt-decode";

import {
  getCookie,
} from "./utility";

if (typeof window.getCookie != 'function') {
  window.getCookie = getCookie;
}

/*
 * Easy implementation using disqus cookie. Not reliable and not secure.
 */

var USER_DATA_STORAGE_KEY = "userData";
var userDataStorage = {
  setData: function (data) {
    var raw_data = data
    if (typeof data === "object") {
      raw_data = JSON.stringify(data);
    }
    localStorage.setItem(USER_DATA_STORAGE_KEY, raw_data);
  },
  getData: function () {
    return JSON.parse(localStorage.getItem(USER_DATA_STORAGE_KEY));
  },
  clearData: function () {
    localStorage.removeItem(USER_DATA_STORAGE_KEY);
  }
}

function fullData(resolve, reject) {
  fetch('/a0/fulldata')
    .then(response => response.json())
    .then(data => resolve(data));
}

function syncFullData() {
  new Promise(fullData).then(
    data => {
      userDataStorage.setData(data);
    });
}

function authSessionInit(resolve, reject) {

  var userInfo = {
    loginStatus: "Anonymous"
  }
  try {
    var jwtCookie = decodeURIComponent(getCookie(JWT_COOKIE));
    if (jwtCookie !== "") {
      var jwt_token = jwtCookie;
      userInfo = jwt_decode(jwt_token);
      if (userInfo.email_verified === true) {
        userInfo.loginStatus = "Registered";
      } else {
        userInfo.loginStatus = "Pending";
      }
      var userFullData = userDataStorage.getData();
      if (userFullData != null) {
        userInfo.primaryEdition = userFullData.user_metadata.primary_edition;
        userInfo.communityTerms = "community_terms_accepted_at" in userFullData.app_metadata;
        userInfo.newsletterUser = "newsletter_id" in userFullData.app_metadata;
      } else {
        syncFullData();
      }
    }
    resolve(userInfo);
  } catch (e) {
    userInfo.error = e.message;
    reject(userInfo);
  }
}

const userInfoLoaded = new CustomEvent("UserInfoLoaded", { authSession: this });
window.authSession = new Promise(authSessionInit)
  .then(userInfo => { document.dispatchEvent(userInfoLoaded); return userInfo; });
window.userDataStorage = userDataStorage;
